import React from 'react';

import HearthBeatLoaderSC from './hb-loader.styled';

const HearthBeatLoader: React.FC<React.HtmlHTMLAttributes<HTMLDivElement>> = (props) => {
  return (
    <HearthBeatLoaderSC {...props}>
      <svg width="100%" height="auto" viewBox="0 0 16 12">
        <polyline className="back" points="1,6 4,6 6,11 10,1 12,6 15,6" />
        <polyline className="front" points="1,6 4,6 6,11 10,1 12,6 15,6" />
      </svg>
    </HearthBeatLoaderSC>
  );
};

export default React.memo(HearthBeatLoader);
